import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { Col, Container, Row } from "react-bootstrap";
import { AxisLineSeparator } from "../components/AxisLineSeparator";
import { OutboundPostmarkLink } from "../util/Links";

const UserMessageModal = ({ visible, close, message }) => {
  if (message === null || message === undefined) return;
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {message?.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Container>
            <Row>
              <Col>Recipiant:</Col>
              <Col className={"fw-bold"}>
                <Link
                  className={"text-axis-link text-decoration-none fw-bold"}
                  to={{
                    pathname: `/users/${message?.user?.id}`,
                  }}
                >
                  {message?.user?.surname}, {message?.user?.forename}
                </Link>
              </Col>
            </Row>

            <Row>
              <Col>Sender:</Col>
              <Col className={"fw-bold"}>
                {message?.sender !== null ? (
                  <Link
                    className={"text-axis-link text-decoration-none fw-bold"}
                    to={{
                      pathname: `/users/${message?.sender?.id}`,
                    }}
                  >
                    {message?.sender?.surname}, {message?.sender?.forename}
                  </Link>
                ) : (
                  "Automatic"
                )}
              </Col>
            </Row>
            <Row>
              <Col>Push:</Col>{" "}
              <Col className={"fw-bold"}>
                {message?.push === true ? "Yes" : "NO"}
              </Col>
            </Row>
            <Row>
              <Col>Email:</Col>{" "}
              <Col className={"fw-bold"}>
                {OutboundPostmarkLink(message?.postMarkMessageId)}
              </Col>
            </Row>
            <Row>
              <Col>Seen:</Col>{" "}
              <Col className={"fw-bold"}>
                {message?.seen === true ? "Yes" : "NO"}
              </Col>
            </Row>
            <Row>
              <Col>Expires:</Col>{" "}
              <Col className={"fw-bold"}>
                {AxisDateTimeFull(message?.expires)}
              </Col>
            </Row>
            <Row>
              <Col>Created:</Col>{" "}
              <Col className={"fw-bold"}>
                {AxisDateTimeFull(message?.created)}
              </Col>
            </Row>
          </Container>
          <AxisLineSeparator />
          <Container id={"user-message-container"}>
            <Row>
              <pre className={"pre-wrap"}>{message?.message}</pre>
            </Row>
          </Container>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className={"w-50"} onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserMessageModal;
